import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterTable',
})
export class FilterTablePipe implements PipeTransform {
  transform(value: any, searchText: any, filterSome?: boolean): any {

    // selectColumns= ['task', 'notify
    if (!searchText) {
      return value;
    } if (filterSome) {
      return value.filter((data: any) => this.matchValue(data.task, searchText) || this.matchValue(data.notify, searchText));

    }
    return value.filter((data: any) => this.matchValue(data, searchText));

  }

  matchValue(data: { [x: string]: string; }, value: string) {
    const regexDate = new RegExp(/(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d)|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d)/, 'ig');
    const dataToModify = JSON.parse(JSON.stringify(data));

    Object.keys(dataToModify).map((key) => {
      const fieldData = dataToModify[key];
      if (regexDate.test(fieldData)) {
        dataToModify[key] = dataToModify[key].slice(0, 10).split('-').reverse().join('-');
        dataToModify[`${key}slash`] = dataToModify[key].split('-').join('/');
      }
    });

    return Object.keys(dataToModify)
      .map((key) => new RegExp(value.split('.').join(''), 'gi').test(dataToModify[key]))
      .some((result) => result);

  }

}
